/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SkumapTemplatesTemplateIdItemsItemIdAssociateDelete$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
  itemId: string;
}

export function skumapTemplatesTemplateIdItemsItemIdAssociateDelete(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdItemsItemIdAssociateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdItemsItemIdAssociateDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

skumapTemplatesTemplateIdItemsItemIdAssociateDelete.PATH = '/skumap/templates/{templateId}/items/{itemId}/associate';
